/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Drastic_Tech_Embed_Start_LogInputs */

const en_drastic_tech_embed_start_log = /** @type {(inputs: Drastic_Tech_Embed_Start_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----Embedding closed captioning into ${i?.name}-----`)
};

const fr_drastic_tech_embed_start_log = /** @type {(inputs: Drastic_Tech_Embed_Start_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----Integration des sous-titres dans ${i?.name}-----`)
};

const de_drastic_tech_embed_start_log = /** @type {(inputs: Drastic_Tech_Embed_Start_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----Einbetten von Untertiteln in ${i?.name}-----`)
};

const it_drastic_tech_embed_start_log = /** @type {(inputs: Drastic_Tech_Embed_Start_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----Incorporamento dei sottotitoli in ${i?.name}-----`)
};

const ru_drastic_tech_embed_start_log = /** @type {(inputs: Drastic_Tech_Embed_Start_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Встраивание субтитров в ${i?.name}-----`)
};

const es_drastic_tech_embed_start_log = /** @type {(inputs: Drastic_Tech_Embed_Start_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----Incorporación de subtítulos en ${i?.name}-----`)
};

const zh_cn2_drastic_tech_embed_start_log = /** @type {(inputs: Drastic_Tech_Embed_Start_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----将隐藏式字幕嵌入${i?.name}-----`)
};

const ja_drastic_tech_embed_start_log = /** @type {(inputs: Drastic_Tech_Embed_Start_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----クローズドキャプションを${i?.name}に埋め込む-----`)
};

const hi_drastic_tech_embed_start_log = /** @type {(inputs: Drastic_Tech_Embed_Start_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----${i?.name} में क्लोज्ड कैप्शनिंग एम्बेड करना-----`)
};

const pt_pt2_drastic_tech_embed_start_log = /** @type {(inputs: Drastic_Tech_Embed_Start_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-----Incorporando legendas ocultas em ${i?.name}-----`)
};

/**
* | output |
* | --- |
* | "-----Embedding closed captioning into {name}-----" |
*
* @param {Drastic_Tech_Embed_Start_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_embed_start_log = /** @type {((inputs: Drastic_Tech_Embed_Start_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Embed_Start_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_embed_start_log(inputs)
	if (locale === "de") return de_drastic_tech_embed_start_log(inputs)
	if (locale === "it") return it_drastic_tech_embed_start_log(inputs)
	if (locale === "ru") return ru_drastic_tech_embed_start_log(inputs)
	if (locale === "es") return es_drastic_tech_embed_start_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_embed_start_log(inputs)
	if (locale === "ja") return ja_drastic_tech_embed_start_log(inputs)
	if (locale === "hi") return hi_drastic_tech_embed_start_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_embed_start_log(inputs)
	return en_drastic_tech_embed_start_log(inputs)
});